import React from 'react';

const IconMedium = () => (
  <svg xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 1000 1000">
    <title>Medium</title>
    <path  
d="M 0.00,500.00
M 392.50,317.50
C 427.25,324.50 458.00,340.37 483.50,364.50
  549.88,427.00 561.12,527.50 510.38,604.25
  499.88,620.12 477.50,642.75 461.75,653.38
  440.12,668.00 418.88,677.00 392.50,682.62
  381.75,684.88 375.38,685.38 357.50,685.38
  339.62,685.38 333.25,684.88 322.50,682.62
  256.50,668.62 205.00,623.75 183.25,561.38
  175.88,540.38 173.25,523.88 173.25,500.00
  173.25,475.62 175.38,462.38 182.50,441.12
  192.13,412.25 205.50,390.62 227.50,368.75
  257.75,338.37 294.50,320.37 336.38,315.00
  350.50,313.25 377.50,314.50 392.50,317.50 Z
M 667.62,327.50
C 690.75,335.37 710.75,357.62 724.75,391.25
  738.25,424.00 744.25,457.25 744.25,500.00
  744.25,537.25 740.12,565.00 729.88,594.50
  720.75,621.25 709.25,641.12 695.00,655.00
  642.12,706.75 579.12,654.00 563.00,544.38
  560.25,525.75 559.38,492.12 561.12,472.50
  566.00,417.62 584.00,370.37 609.88,345.00
  628.00,327.12 648.25,321.00 667.62,327.50 Z
M 802.00,346.88
C 811.88,356.75 820.12,389.25 825.25,438.75
  827.75,462.75 827.38,542.88 824.62,567.50
  819.50,613.12 811.38,643.62 802.00,653.12
  797.75,657.38 792.12,657.25 788.12,653.00
  778.12,642.12 769.50,606.75 764.88,557.50
  762.38,532.00 762.75,463.12 765.50,436.50
  772.25,368.00 787.00,331.88 802.00,346.88 Z" />    </svg>
);

export default IconMedium;
